// src/services/api-core.js - Core API functions only
import { config } from "../config";
import { getToken, removeToken } from "./api-auth";

const API_BASE_URL = config.API_URL;

// Enhanced API request function with better error handling and security
// Optimized API request function
export const apiRequest = async (endpoint, options = {}) => {
  const token = getToken();
  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(!(options.body instanceof FormData) && {
      "Content-Type": "application/json",
    }),
    ...options.headers,
  };

  const config = {
    mode: "cors",
    credentials: "include",
    ...options,
    headers,
  };

  // Stringify JSON bodies
  if (
    config.body &&
    typeof config.body === "object" &&
    !(config.body instanceof FormData)
  ) {
    config.body = JSON.stringify(config.body);
  }

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);

    if (response.status === 401) {
      removeToken();
      throw new Error("Authentication required");
    }

    if (!response.ok) {
      const error = await response
        .json()
        .catch(() => ({ detail: `HTTP ${response.status}` }));
      throw new Error(error.detail);
    }

    return response.status !== 204 ? response.json() : null;
  } catch (error) {
    if (
      error.name === "TypeError" &&
      error.message.includes("Failed to fetch")
    ) {
      throw new Error("Network error: Unable to connect to server");
    }
    throw error;
  }
};

export default apiRequest;
